var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1{fill:#429cd6}.cls-2{fill:#fff}.cls-3{fill:none}\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    twitter-color\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15 29A14 14 0 1 0 1 15a14 14 0 0 0 14 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.94 12v.4a8.73 8.73 0 0 1-13.42 7.3 6.38 6.38 0 0 0 .74 0 6.14 6.14 0 0 0 3.81-1.31A3.07 3.07 0 0 1 9.2 16.3a4.14 4.14 0 0 0 .58 0 3.24 3.24 0 0 0 .81-.1 3.06 3.06 0 0 1-2.46-3 3.07 3.07 0 0 0 1.39.39 3.07 3.07 0 0 1-.95-4.1 8.71 8.71 0 0 0 6.32 3.21 3.44 3.44 0 0 1-.08-.7 3.07 3.07 0 0 1 5.31-2.1 6 6 0 0 0 1.95-.74 3.06 3.06 0 0 1-1.35 1.69 6.18 6.18 0 0 0 1.77-.48A6.61 6.61 0 0 1 20.94 12"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15,
    cy: 15,
    r: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconTwitter);
export default __webpack_public_path__ + "static/media/social-icon-twitter.eca358ae4acdec8c77d7b292adfac04d.svg";
export { ForwardRef as ReactComponent };